import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimeMaskDirective } from './time-mask.directive';

@NgModule({
  declarations: [TimeMaskDirective],
  imports: [CommonModule],
  exports: [TimeMaskDirective]
})
export class TimeMaskModule {}